import React from "react";

import { BrowserRouter, Route, Routes } from "react-router-dom";

import Home from "./Pages/Home";

const RoutesJs = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="*" element={<Home />} />
      </Routes>
    </BrowserRouter>
  );
};

export default RoutesJs;
